<template>
  <div class="player">
    <video
      ref="video"
      controls
      autoplay
      class="player__video"
    />

    <div
      class="player__top-controls"
      :class="{ 'player__top-controls--visible': isVisibleTopControls }"
    >
      <button
        class="player__button-close"
        @click.prevent="close"
      >
        <FontAwesomeIcon icon="times" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import shaka from 'shaka-player'

export default {
  name: 'PlayerVideos',

  data () {
    return {
      isVisibleTopControls: false,
      topControlsTimeout: null
    }
  },

  computed: {
    ...mapState('videos', ['videoPlaying'])
  },

  methods: {
    ...mapMutations('videos', ['SET_VIDEO_PLAYING']),

    close () {
      this.SET_VIDEO_PLAYING(null)
    },

    closeKeyup (event) {
      if (event.key === 'Escape') {
        this.close()
      }
    },

    topControlsShow (isVisible) {
      this.isVisibleTopControls = true

      clearTimeout(this.topControlsTimeout)

      this.topControlsTimeout = setTimeout(this.topControlsHide, 2000)
    },

    topControlsHide (isVisible) {
      this.isVisibleTopControls = false
    },

    async initPlayer () {
      const video = this.$refs.video
      const player = new shaka.Player(video)

      this.player = player

      player.addEventListener('error', this.onErrorEvent)

      try {
        await player.load(this.videoPlaying)
      } catch (e) {
        this.onError(e)
      }
    },

    onErrorEvent (event) {
      this.onError(event.detail)
    },

    onError (error) {
      console.error('Error code', error.code, 'object', error)
    }
  },

  created () {
    window.addEventListener('keyup', this.closeKeyup)
    window.addEventListener('mousemove', this.topControlsShow)

    document.body.style.overflow = 'hidden'
  },

  mounted () {
    shaka.polyfill.installAll()

    if (shaka.Player.isBrowserSupported()) {
      this.initPlayer()
    } else {
      console.error('Browser not supported!')
    }
  },

  beforeDestroy () {
    document.body.style.overflow = 'auto'

    window.removeEventListener('keyup', this.closeKeyup)
    window.removeEventListener('mousemove', this.topControlsShow)
  }
}
</script>

<style lang="scss" scoped>
.player {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(#000, 0.95);

  &__top-controls {
    z-index: 99;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    opacity: 0;
    transform: translateY(-100%);
    transition: all 0.3s;
    background-image: linear-gradient(rgba(#000, 0.5), transparent);

    &--visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__button-close {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 10px;
    border: 0;
    outline: 0;
    background: none;
    color: #fff;
    font-size: 40px;
  }

  &__video {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: 0;
  }
}
</style>
